import React, { useEffect } from "react";
import { Helmet } from "react-helmet";
import Header from "../componets/Header";
import Footer from "../componets/Footer";
import { Link } from "react-router-dom";
import { fetchBannerData } from "../reducer/thunks";
import { useDispatch, useSelector } from "react-redux";
import { useNavigate } from "react-router-dom";
import { TypeAnimation } from "react-type-animation";
import Carousel from 'react-bootstrap/Carousel';



export default function Policy() {
    const dispatch = useDispatch();
    const navigate = useNavigate();

    // Destructuring with different names to avoid conflict
    const {
        data,
        loading: bannerLoading,
        error: bannerError,
    } = useSelector((state) => state.data);

    useEffect(() => {
        dispatch(fetchBannerData());
    }, []);
    return (
        <>
            <Helmet>
                <title>Local Heros</title>
                <meta
                    name="description"
                    content="This is a description of your page."
                />
                <meta name="keywords" content="local heroes, community, volunteer" />
            </Helmet>
            <Header />

            {/* <section>
        <Carousel className="cor-item">
          <Carousel.Item >
           <img src={require("../constant/images/banner1.jpeg")} className="w-100" />
            <div className="carousel-caption carousel-content mt-80">
            <TypeAnimation
              sequence={[
                `The hunger pang Biryani`,
                2000,
                `The No nonsense Biryani`,
                2000,
                ` The Happy Wala Biryani`,
                2000,
                `The Biryani of Mysore`,

              ]}
              repeat={Infinity}
              wrapper="h3"
            />
          </div>
          </Carousel.Item>
          <Carousel.Item >
          <img src={require("../constant/images/box-image.png")} className="w-100" />
            <Carousel.Caption>
             
            </Carousel.Caption>
          </Carousel.Item>
          <Carousel.Item >
          <img src={require("../constant/images/box-image.png")} className="w-100" />
            <Carousel.Caption>
              
            </Carousel.Caption>
          </Carousel.Item>
        </Carousel>

      </section> */}
            <section className="mt-5 mt-lg-0">
                <Carousel className="cor-item">
                    <Carousel.Item >
                        {/* <img src={require("../constant/images/banner1.jpeg")} className="w-100" /> */}

                        <picture>
                            <source
                                media="(min-width: 768px)"
                                srcSet={require("../constant/images/banner1.jpeg")}
                            />
                            <source
                                media="(max-width: 767px)"
                                srcSet={require("../constant/images/mob-banner-1.jpg")}
                            />
                            <img
                                src={require("../constant/images/banner1.jpeg")}
                                alt="Flowers"
                                style={{ width: "100%" }}
                            />
                        </picture>

                        <div className="carousel-caption carousel-content mt-80">
                            <TypeAnimation
                                sequence={[
                                    `The Hunger Pang Biryani`,
                                    2000,
                                    `The No Nonsense Biryani`,
                                    2000,
                                    ` The Happy Wala Biryani`,
                                    2000,
                                    `The Biryani Of Mysore`,
                                    2000

                                ]}
                                repeat={Infinity}
                                wrapper="h3"
                            />
                        </div>
                    </Carousel.Item>
                    <Carousel.Item >
                        {/* <img src={require("../constant/images/box-image.png")} className="w-100" /> */}
                        <picture>
                            <source
                                media="(min-width: 768px)"
                                srcSet={require("../constant/images/box-image.png")}
                            />
                            <source
                                media="(max-width: 767px)"
                                srcSet={require("../constant/images/mbanner-box.png")}
                            />
                            <img
                                src={require("../constant/images/box-image.png")}
                                alt="Flowers"
                                style={{ width: "100%" }}
                            />
                        </picture>

                        <Carousel.Caption>

                        </Carousel.Caption>
                    </Carousel.Item>

                </Carousel>

            </section>

            <section className="breadcum-bg " style={{ maxHeight: "60px" }}></section>
            <section className="my-md-5 my-3  bg-light"></section>
            <section className="py-lg-5 ">
                <div className="container about-box cont-bg">
                    <div className="row justify-content-center">
                        <div className="col-md-12 text-center mb-4">
                            <h2 className="theme-color">Privacy Policy</h2>
                        </div>
                    </div>
                    <div className="row py-5">
                        <div className="col-md-12 pb-5 pb-lg-0">
                            <div className="col-md-12 mb-4">
                                <p style={{ textAlign: 'justify', whiteSpace: "pre-wrap" }}>
                                    <strong> 1. Introduction </strong>
                                    <ul> This policy explains how we LocalHeroes, use the personal information which you provide to us when using our service, including but not limited to our website and mobile applications (jointly referred as “Website”).</ul>

                                    <ul>Please read this Privacy Policy and understand it before using our services. By visiting and/or ordering services on this Website, you agree and, where required, consent to the collection, use and transfer of your information as set out in this policy.</ul>

                                    <strong> 2. What information do we collect about you? </strong>
                                    <ul>We collect personal information from you when you order goods or services from us or use our Website.</ul>

                                    <ul>We also collect information when you complete any customer survey. Website usage information may also be collected using cookies (as defined below). LocalHeroes will collect information that personally identifies you and/or your location, where required (this may include your name, email address, home address, telephone number, geolocation, etc.), but only when you voluntarily give it to us. </ul>

                                    <ul> We collect this information exclusively to carry out the functions offered on the Website and to provide you with offers and information about LocalHeroes and other services we think you may be interested in.</ul>

                                    <ul> We might collect this personal information through: online food ordering; entry into competitions; subscribing to our newsletter; creating a user account; sending 'contact us' messages or other correspondence through the Website; or through advertising, research and direct marketing. We do not collect sensitive information about you.</ul>

                                    <strong> 3. Cookies</strong>
                                    <ul> Some of the information collected will not personally identify you but will instead track your use of the Website so that we can better understand how the Website is used by customers and in turn enhance and improve your experience in ordering food.</ul>

                                    <ul> We may obtain this information by use of cookies. Cookies are a small data file transferred to your device that recognizes and identifies your device and allows your device to 'remember' information from the Website for future use.</ul>

                                    <ul> Cookies do not contain any information that personally identifies you and we do not use cookies in order to obtain such information - your personal information can only be obtained by LocalHeroes if you actively provide it to us.</ul>

                                    <ul> We may collect technical information from your mobile device or your use of our services through a mobile device, for example, location data and certain characteristics of, and performance data about your device, carrier/operating system including device and connection type, IP address, mobile payment methods etc. Your device and/or the web browser should allow you to refuse cookies if you wish by changing the settings.</ul>

                                    <ul>To find out more about cookies, including how to see what cookies have been set and how to manage and delete them, visit localheros.in.</ul>

                                    <strong> 4. Storage and security of your personal information</strong>

                                    <ul>LocalHeroes will use all reasonable endeavours to maintain the security of your personal information and to protect your personal information from misuse, interference and loss and against unauthorized access, modification or disclosure.</ul>

                                    <ul>LocalHeroes will destroy any personal information it holds about you which it no longer requires under the terms of this Privacy Policy. Where you have chosen a password to access certain services of the Website, you are responsible for keeping your password confidential.</ul>

                                    <ul>We recommend not sharing your password with anyone. Due to the nature of the internet, LocalHeroes does not provide any guarantee or warranty regarding the security of your personal information during transmission to us or storage by us and you acknowledge that you disclose your personal information to us at your own risk.</ul>

                                    <ul>Please contact us immediately if you become aware or have reason to believe there has been any unauthorized use of your personal information in connection with the Website.</ul>

                                    <strong>5. How will we use the information we collect from you?</strong>
                                    <ul>You consent to LocalHeroes collecting and using your personal information for processing and delivering the order/s placed on the Website and any other service provided through the Website.</ul>

                                    <ul>In particular you expressly consent that LocalHeroes may disclose your personal information, including your name, email address, physical address and telephone number to riders delivering your order, either employed by LocalHeroes or by third parties providing delivery services to LocalHeroes.</ul>

                                    <ul>You consent to LocalHeroes using your personal information for advertising and direct marketing purposes in order to inform you about the Website and the goods and services it provides, or other matters that it believes will be of interest to you.</ul>

                                    <ul>LocalHeroes may disclose your personal information, and you consent to the disclosure of your personal information, to: other entities within the LocalHeroes group of companies; and third parties engaged by LocalHeroes or other members of the LocalHeroes group to perform functions or provide products and services on our behalf such as processing payments, mail outs, debt collection, research, statistical information, marketing and direct or indirect advertising.</ul>

                                    <ul>If you would like to unsubscribe from receiving direct marketing communications from LocalHeroes or do not want us to share your personal information with other parties, please e-mail us at support@LocalHeroes.com or follow the steps to unsubscribe which are presented in every communication you receive from us, requesting your personal information be removed from our mailing list.</ul>

                                    <ul>We will use reasonable endeavors to comply with your request within a reasonable period of receipt of your request. Please note that the withdrawal of any authorizations for processing of your personal information by third parties may result in us not being able to provide you with any services.</ul>

                                    <ul>LocalHeroes reserves the right to disclose your personal information if it is required or authorized to do so by law, or, if it is reasonably necessary in its opinion to protect the rights or property of LocalHeroes or any third party, or to avoid injury to any person. If the LocalHeroes business is sold or merges with another entity then some or all of your personal information may be passed to a third party.</ul>

                                    <strong>6. Access to your information</strong>
                                    <ul>LocalHeroes will use all reasonable endeavors to keep personal information it holds accurate, complete, up-to-date, relevant and not misleading. Please contact us if you would like to access the personal information LocalHeroes holds about you.</ul>

                                    <ul>We will use reasonable endeavors to provide a complete list of your personal information within a reasonable period of receipt of your request. Please email us if you would like to receive a copy of this information – support@LocalHeroes.com.</ul>

                                    <ul>LocalHeroes reserves the right to charge a nominal fee for the processing of this request in accordance with local legislation. You may contact us to correct any of your personal information that is inaccurate, incomplete or out-of-date, or to request that your personal information be deleted. We will use reasonable endeavors to correct or delete your personal information as requested within a reasonable period of receipt of your request.</ul>

                                    <ul>Deletion of your account with LocalHeroes will not automatically delete the personal information held about you. If you would like LocalHeroes to delete all personal information together with the deletion of your account, please follow the steps mentioned-above.</ul>

                                    <ul>Please note that the deletion of your personal information from our database will result in us not being able to provide you with any services.</ul>

                                    <ul>If applicable, any legal requirement on us to maintain certain records of your personal information shall prevail over any of your requests.</ul>

                                    <ul>We may require you to prove your identity before providing you with copies of your personal information.</ul>

                                    <strong>7. Changes to our Privacy Policy</strong>
                                    <ul>LocalHeroes reserves the right to alter all or any part of this Privacy Policy. Any changes thereto will be notified via the Website and, where appropriate, through e-mail notification.</ul>

                                    <strong>8. Other Websites</strong>
                                    <ul>Our Website may have links to other websites. This privacy policy only applies to the Website. You should therefore read the privacy policies of the other websites when you are using those sites.</ul>

                                    <strong>9. Contact</strong>
                                    <ul>All comments, queries and requests relating to our use of your information are welcomed and should be addressed to: localheros@.com.</ul>

                                </p>
                            </div>



                        </div>

                    </div>

                </div>
            </section>



            <Footer />
        </>
    );
}
